module.exports = __webpack_public_path__ + "img/yanlijuan.78f3ffdd.jpg";